/*
 * Copyright (c) 2020. Sanish Manandhar
 * All Rights Reserved
 */

import {
  TASK_TEMPLATE_FETCH_REQUEST,
  TASK_TEMPLATE_UPSERT_REQUEST,
  TASK_TEMPLATE_FETCH_REQUEST_SUCCESS,
  TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS,
  TASK_TEMPLATE_FETCH_REQUEST_FAILURE,
  TASK_TEMPLATE_UPSERT_REQUEST_FAILURE,
  TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST,
  TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS,
  TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE,
  TASK_TEMPLATE_CLEAN_REQUEST,
  SUB_TASK_TEMPLATE_UPSERT_REQUEST,
  SUB_TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS,
  SUB_TASK_TEMPLATE_UPSERT_REQUEST_FAILURE,
  SUB_TASK_TEMPLATE_DELETE_REQUEST,
  SUB_TASK_TEMPLATE_DELETE_REQUEST_SUCCESS,
  SUB_TASK_TEMPLATE_DELETE_REQUEST_FAILURE,
  SUB_TASK_INDEX_STORE_REQUEST,
  SUB_TASK_INDEX_STORE_REQUEST_SUCCESS,
  SUB_TASK_INDEX_STORE_REQUEST_FAILURE,
  SUB_TASK_TEMPLATE_FETCH_REQUEST,
  SUB_TASK_TEMPLATE_FETCH_REQUEST_SUCCESS,
  SUB_TASK_TEMPLATE_FETCH_REQUEST_FAILURE,
  TASK_TEMPLATE_DELETE_REQUEST,
  TASK_TEMPLATE_DELETE_REQUEST_SUCCESS,
  TASK_TEMPLATE_DELETE_REQUEST_FAILURE,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  singlePayload: [],
  singleLoading: false,
  singleErrors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
  dropdown: [],
  dropdownLoading: false,
  dropdownErrors: {},
  subTaskPayload: [],
  subTaskLoading: false,
  subTaskErrors: {},
  subTaskDeletePayload: [],
  subTaskDeleteLoading: false,
  subTaskDeleteErrors: {},
  taskDeletePayload: [],
  taskDeleteLoading: false,
  taskDeleteErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const taskTemplateReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TASK_TEMPLATE_FETCH_REQUEST:
    case TASK_TEMPLATE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TASK_TEMPLATE_FETCH_REQUEST_SUCCESS:
    case TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.limit,
          total: action.data.totalRecords,
          totalPage:
            Math.round(action.data.totalRecords / action.data.limit) +
            (Math.abs(action.data.totalRecords / action.data.limit) >
            Math.round(action.data.totalRecords / action.data.limit)
              ? 1
              : 0),
        },
      });

    case TASK_TEMPLATE_FETCH_REQUEST_FAILURE:
    case TASK_TEMPLATE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST:
      return Object.assign({}, state, {
        dropdownLoading: true,
      });

    case TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        dropdown: action.data,
        dropdownLoading: false,
        dropdownErrors: {},
      });

    case TASK_TEMPLATE_DROPDOWN_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        dropdownLoading: false,
        dropdownErrors: action.error,
      });

    case TASK_TEMPLATE_DELETE_REQUEST:
      return Object.assign({}, state, {
        taskDeleteLoading: true,
      });

    case TASK_TEMPLATE_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        taskDeletePayload: action.data,
        taskDeleteLoading: false,
        taskDeleteErrors: {},
      });

    case TASK_TEMPLATE_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        taskDeleteLoading: false,
        taskDeleteErrors: action.error,
      });

    case SUB_TASK_TEMPLATE_FETCH_REQUEST:
    case SUB_TASK_TEMPLATE_UPSERT_REQUEST:
      return Object.assign({}, state, {
        subTaskLoading: true,
      });

    case SUB_TASK_TEMPLATE_FETCH_REQUEST_SUCCESS:
    case SUB_TASK_TEMPLATE_UPSERT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        subTaskPayload: action.data,
        subTaskLoading: false,
        subTaskErrors: {},
      });

    case SUB_TASK_TEMPLATE_FETCH_REQUEST_FAILURE:
    case SUB_TASK_TEMPLATE_UPSERT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        subTaskLoading: false,
        subTaskErrors: action.error,
      });

    case SUB_TASK_TEMPLATE_DELETE_REQUEST:
      return Object.assign({}, state, {
        subTaskDeleteLoading: true,
      });

    case SUB_TASK_TEMPLATE_DELETE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        subTaskDeletePayload: action.data,
        subTaskDeleteLoading: false,
        subTaskDeleteErrors: {},
      });

    case SUB_TASK_TEMPLATE_DELETE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        subTaskDeleteLoading: false,
        subTaskDeleteErrors: action.error,
      });

    case SUB_TASK_INDEX_STORE_REQUEST:
      return Object.assign({}, state, {
        singleLoading: true,
      });

    case SUB_TASK_INDEX_STORE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        singlePayload: action.data,
        singleLoading: false,
        singleErrors: {},
      });

    case SUB_TASK_INDEX_STORE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        singleLoading: false,
        singleErrors: action.error,
      });

    case TASK_TEMPLATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
        subTaskLoading: false,
        subTaskErrors: {},
        subTaskDeleteLoading: false,
        subTaskDeleteErrors: {},
        taskDeleteLoading: false,
        taskDeleteErrors: {},
      });

    default:
      return state;
  }
};

export default taskTemplateReducer;
